import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateLogFrequencyRequirementCache,
  LogFrequencyRequirementCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/logFrequencyRequirementCacheRegister';
import { FrequencyRequirementResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseFrequencyRequirementCreateParams = {
  config?: MutationConfig<FrequencyRequirementResponse, Api.ErrorResponse>;
};

export const useFrequencyRequirementCreate = (
  params?: UseFrequencyRequirementCreateParams,
) =>
  useMutation(Api.createFrequencyRequirement, {
    ...params?.config,
    onSuccess: async (createdFrequencyRequirement, mutationFuncParams) => {
      const { organizationId, logId, projectId } = mutationFuncParams;
      invalidateLogFrequencyRequirementCache(
        LogFrequencyRequirementCacheEvents.CREATE,
        {
          organizationId,
          logId,
          projectId,
          logFrequencyRequirementId: createdFrequencyRequirement.id,
        },
      );
      return params?.config?.onSuccess?.(
        createdFrequencyRequirement,
        mutationFuncParams,
      );
    },
  });
